import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-courses-grid-style-two-columns-three-page',
  templateUrl: './courses-grid-style-two-columns-three-page.component.html',
  styleUrls: ['./courses-grid-style-two-columns-three-page.component.scss']
})
export class CoursesGridStyleTwoColumnsThreePageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
